import { Chart } from 'react-google-charts';

import AdminLayout from '../../layout/AdminLayout';
import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import * as Server from '../../assets/js/Server';
import { options } from './incentiveOrg';

export default function Organization(){
  const [orgItemList, setOrgItemList] = useState([]);
  const [searchParams] = useSearchParams();

  const getOrgItemList = () => {
    Server.sendGet('shopify/sales/org', {
      salesPersonId: searchParams.get('salesPersonId')
    }, getOrgItemListCallback).then();
  }

  const getOrgItemListCallback = res => {
    setOrgItemList(res?.['resultList'] || []);
  }

  useEffect(() => {
    getOrgItemList();
  }, [searchParams.get('salesPersonId')]);

  // --- 데이터 가공 로직 ---

  // 1. 구글 조직도(OrgChart)용 데이터 변환
  const chartData = useMemo(() => {
    if (!orgItemList || orgItemList.length === 0) return [["Name", "Manager"]];

    const baseData = [["Name", "Manager"]];
    orgItemList.forEach((item) => {
      baseData.push([
        {
          v: item.referralId,
          f: `<div class='node-item'>
                <strong class='node-tit'>${item.salesPersonName}</strong>
                <span class='node-lev'>${item.gid === "0" ? 'Own' : `G${item.gid}`}</span>
                <p class='node-sales'>Sales: ${Number(item.totalSales).toLocaleString()}</p>
              </div>`,
        },
        // 본인(generation 0)은 부모가 없고, 나머지는 up_referral_id를 부모로 연결
        item.gid === 0 ? "" : item.upReferralId
      ]);
    });
    return baseData;
  }, [orgItemList]);

  // 2. 상단 인센티브 요약 데이터 계산 (본인 포함 G1~G5 합계)
  const summary = useMemo(() => {
    const res = {
      selfSales: 0, g1Sales: 0, g2Sales: 0, g3Sales: 0, g4Sales: 0, g5Sales: 0,
      totalSales: 0, estimatedInc: 0
    };

    orgItemList.forEach(item => {
      const sales = Number(item.totalSales || 0);
      res.totalSales += sales;

      if (item.gid === "0") {
        res.selfSales = sales;
        res.estimatedInc += sales * 0.15;
      } else if (item.gid === "1") {
        res.g1Sales += sales;
        res.estimatedInc += sales * 0.10;
      } else if (item.gid === "2") {
        res.g2Sales += sales;
        res.estimatedInc += sales * 0.05;
      } else if (item.gid === "3") {
        res.g3Sales += sales;
        res.estimatedInc += sales * 0.03;
      } else if (item.gid === "4") {
        res.g4Sales += sales;
        res.estimatedInc += sales * 0.02;
      } else if (item.gid === "5") {
        res.g5Sales += sales;
        res.estimatedInc += sales * 0.01;
      }
    });

    return res;
  }, [orgItemList]);

  // 인센티브 비율 반환 함수 (테이블용)
  const getRate = (gen) => {
    const rates = { 0: '15%', 1: '10%', 2: '5%', 3: '3%', 4: '2%', 5: '1%' };
    return rates[gen] || '0%';
  };
  return (
    <AdminLayout>
      <div className='title'>
        <div className='tit-head'>
          <i />
          <h4>조직도</h4>
        </div>
      </div>
      {/*<div className="util-menu">*/}
      {/*  /!*<div className="menu-in">*!/*/}
      {/*  /!*  <button>누적 매출</button>*!/*/}
      {/*  /!*  <button>월 매출</button>*!/*/}
      {/*  /!*</div>*!/*/}
      {/*</div>*/}
      <div className="content">
        {/*<div className="sales-cnt">*/}
          {/*<label htmlFor="sales">Total Sales</label>*/}
          {/*<input type="text" id="sales" name="sales" />*/}
        {/*</div>*/}
        <Chart
          chartType="OrgChart"
          data={chartData}
          options={options}
          width="100%"
          height="400px"
        />
      </div>
    </AdminLayout>
  )
}
